import { createTheme } from '@mui/material/styles'

export const muiTheme = createTheme()

export const emotionTheme = {
  colors: {
    primary: '#283897',
    secondary: '#2A295C',
    lightest: '#FFF',
    myapps: {
      blue: {
        400: '#173DA6',
        500: '#1A3478',
        800: '#0C142E'
      },
      gray: {
        200: 'rgba(255, 255, 255, 0.3)',
        500: '#242c43'
      },
      menus: {
        subMenu: 'rgba(255, 255, 255, 0.8)',
        logoText: '#E5E5EA'
      }
    },
    success: {
      color: '#34A866',
      background: 'rgba(52, 168, 102, 0.15)'
    },
    warning: '#2A295C',
    error: {
      color: '#E00',
      background: 'rgba(168, 52, 52, 0.15)'
    },
    red: {
      color: '#831313',
      background: '#F8C6C6'
    },
    purple: {
      color: '#915FC8',
      background: 'rgba(145, 95, 200, 0.05)'
    },
    orange: {
      color: '#BD8E39',
      background: '#FEEFD3'
    },
    background: {
      hover: 'rgba(43, 55, 151, 0.08)'
    },
    shadows: {
      header: 'rgba(40, 56, 151, 0.1)',
      sideBar: 'rgba(40, 56, 151, 0.1)'
    },
    border: {
      light: '#d8d8eb',
      disabled: '#D8D8DC'
    },
    gray: {
      100: '#f6f6fc',
      200: '#EDEEF2',
      300: '#D4D7EA',
      400: '#767676',
      light: '#e7e9f7',
      footer: '#EEEFF7',
      dark: '#5C5C5C',
      disabled: '#F0F1F7',
      weekEndColumn: 'rgba(212, 215, 234, 0.20)',
      scrollbar: '#7A7A7A'
    },
    yellow: {
      100: '#FEF9C2',
      300: '#FCBD4C',
      500: '#984B1F'
    },
    green: {
      100: '#C6F6D5',
      500: '#228085',
      light: '#34A866',
      color: '#1F653D',
      background: '#D3F1E0'
    },
    blue: {
      line: '#199CDA4D',
      head: '#BEE3F8',
      dark: '#2A4365'
    },
    teal: {
      color: '#228085',
      background: 'rgba(34, 128, 133, 0.15)'
    }
  },
  sizes: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem'
  },
  radius: {
    sm: '0.25rem',
    md: '1rem',
    lg: '2.1333rem'
  },
  fontSizes: {
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem'
  },
  screenSizes: {
    tablet: '40rem',
    laptop: '60rem',
    desktop: '80rem',
    wide: '102.4rem'
  },
  fontFamily: {
    openSans: 'Open Sans',
    sansaPro: 'Sansa Pro, sans-serif'
  }
}
